import { render, staticRenderFns } from "./ModalCompanyAdmin.vue?vue&type=template&id=2fe62c15"
import script from "./ModalCompanyAdmin.vue?vue&type=script&lang=js"
export * from "./ModalCompanyAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports